module.exports = __webpack_public_path__ + "img/foto_7.0856f2c2.png";